const config = {
  baseURLProd: 'http://4.234.0.139:82/api/',
  baseURLDev: 'http://4.234.0.139:82/api/',
};
export default config;
